
export default {
    data() {
      return {
        apis:{//接口列表  
            hasRoleByKey:'oa/official/hasRoleByKey',//获取用户权限 

        },  
        canDel:false,
      };
    },
    props: {  
        bizType:null,//业务类型
        bizKey:null,//业务主键
    }, 
     
    mounted() {  
    },    
    methods: { 
         
        del(){
            let url="";
            switch(this.bizType){
                case 1:
                    url="oa/official/sendDoc/delByStatus";
                    break;
                case 2:
                    url="oa/official/receive/delByStatus";
                    break; 
                case 3:
                    url="oa/official/opinion/delByStatus";
                    break;      
                case 4:
                    url="oa/official/sign/delByStatus";
                    break;      
                case 5:
                    url="oa/official/rePort/delByStatus";
                    break;      
                case 6:
                    url="oa/official/task/delByStatus";
                    break;      
                case 7:
                    url="oa/official/leave/delByStatus";
                    break;      
                case 8:
                    url="oa/official/business/delByStatus";
                    break;      
                case 9:
                    url="oa/official/overtime/delByStatus";
                    break;      
                case 10:
                    url="oa/official/overtime/delByStatus";
                    break;      
                case 11:
                    url="oa/official/info/delByStatus";
                    break;      
                case 12:
                    url="oa/motion/delByStatus";
                    break;      
                case 13:
                    url="oa/sign/delByStatus";
                    break;      
                case 14:
                    url="oa/minutes/delByStatus";
                    break;      
                case 15:
                    url="oa/official/overtime/delByStatus";
                    break;              
            } 

            if(url!=""){  
                this.$confirm('是否确认删除文件?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$post({
                        url: url,
                        params: this.bizKey
                    }).then(rsp => {
                        this.$emit('list');
                    })
                }).catch(() => {
                        
                });  
            }
        }
    }
  };


// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/btnDel/src/btnDel.js